import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getCmpReferenceData = createAsyncThunk(
  'stop/getCmpReferenceData',
  async (params) => {
    const { cmpReferenceUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(cmpReferenceUrl, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const cmpReferenceSlice = createSlice({
  name: 'stop/cmpReference',
  initialState: null,
  reducers: {
    resetCmpReference: () => null,
  },
  extraReducers: {
    [getCmpReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetCmpReference } = cmpReferenceSlice.actions;

export default cmpReferenceSlice.reducer;
